import "./mjai.690548ff.js";
import "./mobile.5203f183.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7651"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7651"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9wRj8", function(module, exports) {

$parcel$export(module.exports, "ensurePwaManifestLink", () => $188bcd54012ffe39$export$26668c9cb513cf4a);

var $iRbTC = parcelRequire("iRbTC");
function $188bcd54012ffe39$export$26668c9cb513cf4a() {
    if (typeof document === 'undefined') return;
    const basePath = (0, $iRbTC.getBasePath)();
    const normalizedBase = basePath.endsWith('/') ? basePath : `${basePath}/`;
    const href = `${normalizedBase}manifest.webmanifest`;
    const absoluteHref = new URL(href, window.location.origin).toString();
    const existing = document.querySelector('link[rel="manifest"]');
    const link = existing ?? document.createElement('link');
    if (!existing) {
        link.rel = 'manifest';
        document.head.appendChild(link);
    }
    if (link.href !== absoluteHref) link.href = href;
}

});
parcelRegister("iRbTC", function(module, exports) {

$parcel$export(module.exports, "getBasePath", () => $efba685e62bb2577$export$9099264ed9b1c55a);
$parcel$export(module.exports, "getWsUrl", () => $efba685e62bb2577$export$28999b747e987c5);
function $efba685e62bb2577$export$9099264ed9b1c55a() {
    // In development we assume everything is served from root.
    // @ts-ignore
    const env = "production";
    if (env !== 'production') return '/';
    let pathname = window.location.pathname;
    // Normalize to a directory path.
    if (!pathname.endsWith('/')) pathname = pathname.substring(0, pathname.lastIndexOf('/') + 1);
    // The app can be hosted under a subpath (e.g. /mjlab/).
    // Resolve that base path by stripping known entry route prefixes.
    const markers = [
        'oauth',
        'chatgpt-hand',
        'coach',
        'hand',
        'mobile',
        'computer',
        'me',
        'practice',
        'calc',
        'evplus',
        'ev'
    ];
    for (const m of markers){
        const idx = pathname.indexOf(`/${m}/`);
        if (idx >= 0) return pathname.slice(0, idx + 1);
    }
    return pathname;
}
function $efba685e62bb2577$export$28999b747e987c5() {
    // @ts-ignore
    const env = "production";
    if (env !== 'production') return 'ws://localhost:1235';
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const wsHost = window.location.host;
    const basePath = $efba685e62bb2577$export$9099264ed9b1c55a();
    return `${wsProtocol}//${wsHost}${basePath}ws`;
}

});


parcelRegister("j0QBl", function(module, exports) {

$parcel$export(module.exports, "syncProfileToGameClient", () => $8d8d57ef93ec07a6$export$724c38314ff3764);

var $8PAWz = parcelRequire("8PAWz");
async function $8d8d57ef93ec07a6$export$724c38314ff3764(client, options) {
    try {
        const { user: user, loginToken: loginToken } = await (0, $8PAWz.ensureUser)(options);
        const nickname = user.nickname?.trim();
        if (nickname) client.nicks.set(client.playerId(), nickname);
        if (Number.isInteger(user.avatarIndex)) client.avatars.set(client.playerId(), user.avatarIndex);
        client.bindLoginToken(loginToken);
        return true;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('failed to sync user profile', err);
        return false;
    }
}

});
parcelRegister("8PAWz", function(module, exports) {

$parcel$export(module.exports, "getLoginToken", () => $9e7ee0b2974913c0$export$b154f1a67bb7b5d9);
$parcel$export(module.exports, "setLoginToken", () => $9e7ee0b2974913c0$export$4dbcba3b4ea11a19);
$parcel$export(module.exports, "getApiBaseUrl", () => $9e7ee0b2974913c0$export$4d28219d42798a75);
$parcel$export(module.exports, "updateMe", () => $9e7ee0b2974913c0$export$8ddaddf355aae59c);
$parcel$export(module.exports, "uploadMeAvatar", () => $9e7ee0b2974913c0$export$e5f48a70142e06bf);
$parcel$export(module.exports, "resetApiToken", () => $9e7ee0b2974913c0$export$c5eea955a88464ec);
$parcel$export(module.exports, "resetLoginToken", () => $9e7ee0b2974913c0$export$c2a104aacbacefaa);
$parcel$export(module.exports, "newbieStart", () => $9e7ee0b2974913c0$export$ea49889f7616fcf2);
$parcel$export(module.exports, "newbieNew", () => $9e7ee0b2974913c0$export$92756d14cbd5cc30);
$parcel$export(module.exports, "guobiaoNewbieStart", () => $9e7ee0b2974913c0$export$109dfbde830570f5);
$parcel$export(module.exports, "guobiaoNewbieNew", () => $9e7ee0b2974913c0$export$dd05c0c1494fd830);
$parcel$export(module.exports, "bindActiveChatgptGame", () => $9e7ee0b2974913c0$export$3342556cc7b4714a);
$parcel$export(module.exports, "createChatgptOAuthAuthorizeRedirect", () => $9e7ee0b2974913c0$export$f1f66155db049887);
$parcel$export(module.exports, "fetchActiveGame", () => $9e7ee0b2974913c0$export$2e1b665d364d6930);
$parcel$export(module.exports, "abandonActiveGame", () => $9e7ee0b2974913c0$export$8c656dddbbc2d2ef);
$parcel$export(module.exports, "fetchTrusteeStatus", () => $9e7ee0b2974913c0$export$82bc2c03e989df27);
$parcel$export(module.exports, "disableTrustee", () => $9e7ee0b2974913c0$export$76eb5b5e3bdae2de);
$parcel$export(module.exports, "ensureUser", () => $9e7ee0b2974913c0$export$497e1c057f8b78d1);
$parcel$export(module.exports, "fetchMeWithToken", () => $9e7ee0b2974913c0$export$348031c3192ccb78);
$parcel$export(module.exports, "fetchMatchPointsInfo", () => $9e7ee0b2974913c0$export$2841f326108dece9);
$parcel$export(module.exports, "fetchMatchPointsInfoWithToken", () => $9e7ee0b2974913c0$export$d2f7ba77b6258c18);
$parcel$export(module.exports, "claimDailyMatchPoints", () => $9e7ee0b2974913c0$export$9f47f53f8aa750c6);

var $iRbTC = parcelRequire("iRbTC");

var $2glTM = parcelRequire("2glTM");
const $9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY = 'mjlab_login_token';
const $9e7ee0b2974913c0$var$LEGACY_LOGIN_TOKEN_KEY = 'autotable_login_token';
let $9e7ee0b2974913c0$var$ensureUserInFlightDefault = null;
let $9e7ee0b2974913c0$var$ensureUserInFlightStrict = null;
function $9e7ee0b2974913c0$export$b154f1a67bb7b5d9() {
    try {
        const current = localStorage.getItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY);
        if (current) return current;
        const legacy = localStorage.getItem($9e7ee0b2974913c0$var$LEGACY_LOGIN_TOKEN_KEY);
        if (legacy) {
            localStorage.setItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY, legacy);
            return legacy;
        }
        return null;
    } catch  {
        return null;
    }
}
function $9e7ee0b2974913c0$export$4dbcba3b4ea11a19(token) {
    try {
        if (token) localStorage.setItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY, token);
        else localStorage.removeItem($9e7ee0b2974913c0$var$LOGIN_TOKEN_KEY);
        // Keep legacy key cleared to avoid confusion.
        if (!token) localStorage.removeItem($9e7ee0b2974913c0$var$LEGACY_LOGIN_TOKEN_KEY);
    } catch  {
    // ignore
    }
}
function $9e7ee0b2974913c0$export$4d28219d42798a75() {
    // @ts-ignore
    const env = "production";
    if (env !== 'production') return 'http://localhost:1235/api';
    const basePath = (0, $iRbTC.getBasePath)();
    return `${window.location.origin}${basePath}api`;
}
async function $9e7ee0b2974913c0$export$12d407bce29ab995() {
    return $9e7ee0b2974913c0$var$apiJson('/auth/anonymous', {
        method: 'POST'
    });
}
async function $9e7ee0b2974913c0$export$2962cbb731e8b886() {
    return $9e7ee0b2974913c0$var$apiJson('/me', {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$8ddaddf355aae59c(patch) {
    return $9e7ee0b2974913c0$var$apiJson('/me', {
        method: 'PATCH',
        auth: true,
        body: patch
    });
}
async function $9e7ee0b2974913c0$export$e5f48a70142e06bf(dataUrl) {
    return $9e7ee0b2974913c0$var$apiJson('/me/avatar', {
        method: 'POST',
        auth: true,
        body: {
            dataUrl: dataUrl
        }
    });
}
async function $9e7ee0b2974913c0$export$c5eea955a88464ec() {
    return $9e7ee0b2974913c0$var$apiJson('/me/reset-api-token', {
        method: 'POST',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$c2a104aacbacefaa() {
    return $9e7ee0b2974913c0$var$apiJson('/me/reset-login-token', {
        method: 'POST',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$ea49889f7616fcf2(options = {}) {
    return $9e7ee0b2974913c0$var$apiJson('/newbie/start', {
        method: 'POST',
        auth: true,
        body: options.chatgptHand ? {
            chatgptHand: true
        } : undefined
    });
}
async function $9e7ee0b2974913c0$export$92756d14cbd5cc30() {
    return $9e7ee0b2974913c0$var$apiJson('/newbie/new', {
        method: 'POST',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$109dfbde830570f5(options = {}) {
    return $9e7ee0b2974913c0$var$apiJson('/guobiao/newbie/start', {
        method: 'POST',
        auth: true,
        body: {
            guobiaoConfig: (0, $2glTM.guobiaoConfigForSeat)(0),
            ...options.chatgptHand ? {
                chatgptHand: true
            } : {}
        }
    });
}
async function $9e7ee0b2974913c0$export$dd05c0c1494fd830() {
    return $9e7ee0b2974913c0$var$apiJson('/guobiao/newbie/new', {
        method: 'POST',
        auth: true,
        body: {
            guobiaoConfig: (0, $2glTM.guobiaoConfigForSeat)(0)
        }
    });
}
async function $9e7ee0b2974913c0$export$3342556cc7b4714a(gameId) {
    return $9e7ee0b2974913c0$var$apiJson('/chatgpt-hand/active', {
        method: 'POST',
        auth: true,
        body: {
            gameId: gameId
        }
    });
}
async function $9e7ee0b2974913c0$export$f1f66155db049887(params) {
    return $9e7ee0b2974913c0$var$apiJson('/chatgpt-oauth/authorize', {
        method: 'POST',
        auth: true,
        body: params
    });
}
async function $9e7ee0b2974913c0$export$2e1b665d364d6930() {
    return $9e7ee0b2974913c0$var$apiJson('/me/active-game', {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$8c656dddbbc2d2ef(gameId) {
    const normalized = typeof gameId === 'string' ? gameId.trim() : '';
    const body = normalized ? {
        gameId: normalized
    } : undefined;
    return $9e7ee0b2974913c0$var$apiJson('/me/active-game/abandon', {
        method: 'POST',
        auth: true,
        body: body
    });
}
async function $9e7ee0b2974913c0$export$82bc2c03e989df27(gameId) {
    const normalized = String(gameId ?? '').trim();
    if (!normalized) throw new Error('missing gameId');
    return $9e7ee0b2974913c0$var$apiJson(`/me/trustee-status?gameId=${encodeURIComponent(normalized)}`, {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$76eb5b5e3bdae2de(gameId) {
    const normalized = String(gameId ?? '').trim();
    if (!normalized) throw new Error('missing gameId');
    return $9e7ee0b2974913c0$var$apiJson('/me/trustee/disable', {
        method: 'POST',
        auth: true,
        body: {
            gameId: normalized
        }
    });
}
async function $9e7ee0b2974913c0$export$497e1c057f8b78d1(options) {
    const strict = options?.strictExistingToken === true;
    const inFlight = strict ? $9e7ee0b2974913c0$var$ensureUserInFlightStrict : $9e7ee0b2974913c0$var$ensureUserInFlightDefault;
    if (inFlight) return inFlight;
    const loader = (async ()=>{
        const existing = $9e7ee0b2974913c0$export$b154f1a67bb7b5d9();
        if (existing) try {
            const { user: user } = await $9e7ee0b2974913c0$export$2962cbb731e8b886();
            return {
                created: false,
                loginToken: existing,
                apiToken: null,
                user: user
            };
        } catch (err) {
            const msg = String(err?.message ?? err);
            // Existing token is invalid.
            if (msg.toLowerCase().includes('unauthorized') || msg.startsWith('401')) {
                $9e7ee0b2974913c0$export$4dbcba3b4ea11a19(null);
                if (strict) throw new Error('unauthorized');
            } else throw err;
        }
        const { loginToken: loginToken, apiToken: apiToken, user: user } = await $9e7ee0b2974913c0$export$12d407bce29ab995();
        $9e7ee0b2974913c0$export$4dbcba3b4ea11a19(loginToken);
        return {
            created: true,
            loginToken: loginToken,
            apiToken: apiToken,
            user: user
        };
    })();
    if (strict) $9e7ee0b2974913c0$var$ensureUserInFlightStrict = loader;
    else $9e7ee0b2974913c0$var$ensureUserInFlightDefault = loader;
    try {
        return await loader;
    } finally{
        if (strict) $9e7ee0b2974913c0$var$ensureUserInFlightStrict = null;
        else $9e7ee0b2974913c0$var$ensureUserInFlightDefault = null;
    }
}
async function $9e7ee0b2974913c0$var$apiJson(path, options) {
    const url = `${$9e7ee0b2974913c0$export$4d28219d42798a75()}${path.startsWith('/') ? '' : '/'}${path}`;
    const headers = {
        'Content-Type': 'application/json'
    };
    const needsAuth = options.auth || typeof options.authToken === 'string';
    if (needsAuth) {
        const loginToken = options.authToken ?? $9e7ee0b2974913c0$export$b154f1a67bb7b5d9();
        if (!loginToken) throw new Error('missing login token');
        headers['Authorization'] = `Bearer ${loginToken}`;
    }
    const resp = await fetch(url, {
        method: options.method,
        headers: headers,
        body: options.body !== undefined ? JSON.stringify(options.body) : undefined
    });
    const text = await resp.text();
    let json = null;
    try {
        json = text ? JSON.parse(text) : null;
    } catch  {
        json = null;
    }
    if (!resp.ok) {
        const msg = json?.error ? String(json.error) : `${resp.status} ${resp.statusText}`;
        const error = new Error(msg);
        error.status = resp.status;
        error.data = json;
        throw error;
    }
    return json;
}
async function $9e7ee0b2974913c0$export$348031c3192ccb78(loginToken) {
    return $9e7ee0b2974913c0$var$apiJson('/me', {
        method: 'GET',
        authToken: loginToken
    });
}
async function $9e7ee0b2974913c0$export$2841f326108dece9() {
    return $9e7ee0b2974913c0$var$apiJson('/me/match-points', {
        method: 'GET',
        auth: true
    });
}
async function $9e7ee0b2974913c0$export$d2f7ba77b6258c18(loginToken) {
    return $9e7ee0b2974913c0$var$apiJson('/me/match-points', {
        method: 'GET',
        authToken: loginToken
    });
}
async function $9e7ee0b2974913c0$export$9f47f53f8aa750c6() {
    return $9e7ee0b2974913c0$var$apiJson('/me/match-points/claim', {
        method: 'POST',
        auth: true
    });
}

});
parcelRegister("2glTM", function(module, exports) {

$parcel$export(module.exports, "readGuobiaoAutoBuhuaPreference", () => $84cff88e5d7cc0f3$export$41bad8cd9b7182b5);
$parcel$export(module.exports, "writeGuobiaoAutoBuhuaPreference", () => $84cff88e5d7cc0f3$export$60d720d3114ad562);
$parcel$export(module.exports, "guobiaoConfigForCurrentPlayer", () => $84cff88e5d7cc0f3$export$d1f81d8a01b9b24f);
$parcel$export(module.exports, "guobiaoConfigForSeat", () => $84cff88e5d7cc0f3$export$32ee3f124acfe185);
const $84cff88e5d7cc0f3$var$AUTO_BUHUA_KEY = 'mjlab.guobiao.autoBuhua';
function $84cff88e5d7cc0f3$export$41bad8cd9b7182b5() {
    try {
        const raw = localStorage.getItem($84cff88e5d7cc0f3$var$AUTO_BUHUA_KEY);
        if (raw === 'false') return false;
        if (raw === 'true') return true;
    } catch  {
    // ignore storage errors and keep the production default.
    }
    return true;
}
function $84cff88e5d7cc0f3$export$60d720d3114ad562(enabled) {
    try {
        localStorage.setItem($84cff88e5d7cc0f3$var$AUTO_BUHUA_KEY, enabled ? 'true' : 'false');
    } catch  {
    // The current hand state still updates through the server even if storage is unavailable.
    }
}
function $84cff88e5d7cc0f3$export$d1f81d8a01b9b24f() {
    return {
        autoBuhua: $84cff88e5d7cc0f3$export$41bad8cd9b7182b5()
    };
}
function $84cff88e5d7cc0f3$export$32ee3f124acfe185(seat) {
    const autoBuhua = $84cff88e5d7cc0f3$export$41bad8cd9b7182b5();
    return {
        autoBuhua: autoBuhua,
        autoBuhuaBySeat: {
            [seat]: autoBuhua
        }
    };
}

});



parcelRegister("fRfgz", function(module, exports) {
$parcel$export(module.exports, "rankOf", () => (parcelRequire("fJUxr")).rankOf);
$parcel$export(module.exports, "suitOf", () => (parcelRequire("fJUxr")).suitOf);
$parcel$export(module.exports, "tileCode", () => (parcelRequire("fJUxr")).tileCode);
$parcel$export(module.exports, "tileKeyFromTypeIndex", () => (parcelRequire("fJUxr")).tileKeyFromTypeIndex);
$parcel$export(module.exports, "tileLabel", () => (parcelRequire("fJUxr")).tileLabel);
parcelRequire("fJUxr");

});
parcelRegister("fJUxr", function(module, exports) {

$parcel$export(module.exports, "tileKeyFromTypeIndex", () => $ab66034f250a8f70$export$39d865791f5ab822);
$parcel$export(module.exports, "suitOf", () => $ab66034f250a8f70$export$68b1463578225122);
$parcel$export(module.exports, "rankOf", () => $ab66034f250a8f70$export$963a9da2cb8cbde1);
$parcel$export(module.exports, "tileCode", () => $ab66034f250a8f70$export$c9d51cf214cf1a64);
$parcel$export(module.exports, "tileLabel", () => $ab66034f250a8f70$export$7ac16b70e04efcd7);
function $ab66034f250a8f70$export$39d865791f5ab822(typeIndex) {
    const base = (typeIndex % 37 + 37) % 37;
    // 红五映射回普通 5
    let idx = base;
    if (idx === 34) idx = 4;
    if (idx === 35) idx = 13;
    if (idx === 36) idx = 22;
    if (idx < 0 || idx >= 27) return null;
    return idx;
}
function $ab66034f250a8f70$export$68b1463578225122(tileKey) {
    if (tileKey < 9) return 'm';
    if (tileKey < 18) return 'p';
    return 's';
}
function $ab66034f250a8f70$export$963a9da2cb8cbde1(tileKey) {
    return tileKey % 9 + 1;
}
function $ab66034f250a8f70$export$c9d51cf214cf1a64(tileKey) {
    return `${$ab66034f250a8f70$export$963a9da2cb8cbde1(tileKey)}${$ab66034f250a8f70$export$68b1463578225122(tileKey)}`;
}
function $ab66034f250a8f70$export$7ac16b70e04efcd7(tileKey) {
    const r = $ab66034f250a8f70$export$963a9da2cb8cbde1(tileKey);
    const s = $ab66034f250a8f70$export$68b1463578225122(tileKey);
    const suitText = s === 'm' ? "\u4E07" : s === 'p' ? "\u7B52" : "\u6761";
    return `${r}${suitText}`;
}

});


parcelRegister("iQieN", function(module, exports) {

$parcel$export(module.exports, "calcBloodHu", () => $3c7d2d63503f82d3$export$b88c99e7e540350);
parcelRequire("fRfgz");
var $fJUxr = parcelRequire("fJUxr");
const $3c7d2d63503f82d3$var$FAN_MULT_QING = 4;
const $3c7d2d63503f82d3$var$FAN_MULT_JIANG = 4;
const $3c7d2d63503f82d3$var$FAN_MULT_YAOJIU = 4;
const $3c7d2d63503f82d3$var$FAN_MULT_DUANYAOJIU = 2;
const $3c7d2d63503f82d3$var$FAN_MULT_7PAIRS = 4;
const $3c7d2d63503f82d3$var$FAN_MULT_GOLD_HOOK = 4;
const $3c7d2d63503f82d3$var$FAN_MULT_PONGPONG = 2;
const $3c7d2d63503f82d3$var$FAN_MULT_PINGHU = 1;
const $3c7d2d63503f82d3$var$FAN_MULT_EVENT = 2;
function $3c7d2d63503f82d3$export$b88c99e7e540350(hand, options) {
    const errors = [];
    const warnings = [];
    const capOpt = options.cap;
    const cap = Number.isFinite(capOpt ?? NaN) && Math.trunc(capOpt) > 0 ? Math.trunc(capOpt) : null;
    const base = options.base;
    if (!Number.isFinite(base) || base <= 0) errors.push("\u5E95\u5206\u5FC5\u987B\u4E3A\u6B63\u6570");
    const huMethod = options.huMethod;
    const remainingOpponents = options.remainingOpponents ?? 0;
    if (huMethod === 'zimo') {
        if (!Number.isInteger(remainingOpponents) || remainingOpponents < 1 || remainingOpponents > 3) errors.push("\u81EA\u6478\u9700\u8981\u586B\u5199\u201C\u5269\u4F59\u672A\u80E1\u5BF9\u624B\u6570\u201D(1-3)");
    }
    const events = options.events ?? {};
    const eventFlags = $3c7d2d63503f82d3$var$normalizeEvents(huMethod, events, errors, warnings);
    const meldCount = hand.melds.length;
    const kongCount = hand.melds.filter((m)=>m.kind === 'gang').length;
    const concealedCount = hand.concealedTiles.length;
    if (meldCount > 4) errors.push("\u526F\u9732\u6700\u591A 4 \u7EC4");
    if (meldCount <= 4) {
        const expectedStandardConcealed = (4 - meldCount) * 3 + 2;
        if (concealedCount !== expectedStandardConcealed) {
            if (meldCount === 0) errors.push(`\u{6697}\u{624B}\u{5F20}\u{6570}\u{5E94}\u{4E3A} 14 \u{5F20}\u{FF08}\u{5F53}\u{524D} ${concealedCount} \u{5F20}\u{FF09}`);
            else errors.push(`\u{5F53}\u{524D}\u{526F}\u{9732} ${meldCount} \u{7EC4}\u{FF0C}\u{6807}\u{51C6}\u{5F62}\u{6697}\u{624B}\u{5E94}\u{4E3A} ${expectedStandardConcealed} \u{5F20}\u{FF08}\u{5F53}\u{524D} ${concealedCount} \u{5F20}\u{FF09}`);
        }
    }
    const countsTotal = new Array(27).fill(0);
    const countsConcealed = new Array(27).fill(0);
    for (const t of hand.concealedTiles){
        if (!Number.isInteger(t) || t < 0 || t >= 27) {
            errors.push("\u6697\u624B\u5305\u542B\u975E\u6CD5\u724C");
            break;
        }
        countsConcealed[t] += 1;
        countsTotal[t] += 1;
    }
    for (const m of hand.melds){
        if (!Number.isInteger(m.tileKey) || m.tileKey < 0 || m.tileKey >= 27) {
            errors.push("\u526F\u9732\u5305\u542B\u975E\u6CD5\u724C");
            break;
        }
        const tileCount = m.kind === 'gang' ? 4 : 3;
        countsTotal[m.tileKey] += tileCount;
    }
    for(let i = 0; i < 27; i++)if (countsTotal[i] > 4) errors.push(`\u{540C}\u{4E00}\u{5F20}\u{724C}\u{6700}\u{591A} 4 \u{5F20}\u{FF08}${$3c7d2d63503f82d3$var$tileKeyHint(i)} \u{5DF2}\u{6709} ${countsTotal[i]} \u{5F20}\u{FF09}`);
    const suits = $3c7d2d63503f82d3$var$suitsUsed(countsTotal);
    if (suits.size > 2) errors.push("\u624B\u724C\u5305\u542B\u4E09\u95E8\u82B1\u8272\uFF08\u82B1\u732A\uFF09\uFF0C\u4E0D\u6EE1\u8DB3\u201C\u6700\u591A\u4E24\u95E8\u82B1\u8272\u624D\u80FD\u80E1\u724C\u201D");
    const rootCount = $3c7d2d63503f82d3$var$countRoots(countsTotal);
    if (errors.length > 0) return $3c7d2d63503f82d3$var$emptyResult(false, errors, warnings);
    const { ok: okHand, ctx: ctx, best: best, reason: reason } = $3c7d2d63503f82d3$var$evaluateHand(countsConcealed, hand.melds, {
        meldCount: meldCount,
        kongCount: kongCount,
        rootCount: rootCount,
        suits: suits,
        standardOnly: !!options.standardOnly
    });
    if (!okHand || !ctx || !best) return $3c7d2d63503f82d3$var$emptyResult(false, [
        reason ?? "\u4E0D\u80FD\u80E1\u724C\uFF1A\u724C\u578B\u4E0D\u6210\u7ACB"
    ], warnings);
    const fans = $3c7d2d63503f82d3$var$buildHandFans(ctx);
    const eventFans = $3c7d2d63503f82d3$var$buildEventFans(huMethod, eventFlags);
    fans.push(...eventFans);
    let multiplierRaw = 1;
    for (const f of fans)multiplierRaw *= f.multiplier;
    const multiplierCapped = cap === null ? multiplierRaw : Math.min(multiplierRaw, cap);
    const payerCount = huMethod === 'zimo' ? remainingOpponents : 1;
    const perOpponent = base * multiplierCapped;
    const winnerGain = perOpponent * payerCount;
    const explanation = $3c7d2d63503f82d3$var$buildExplanation({
        base: base,
        cap: cap,
        huMethod: huMethod,
        payerCount: payerCount,
        perOpponent: perOpponent,
        winnerGain: winnerGain,
        multiplierRaw: multiplierRaw,
        multiplierCapped: multiplierCapped,
        fans: fans
    });
    return {
        ok: true,
        errors: [],
        warnings: warnings,
        fans: fans,
        multiplierRaw: multiplierRaw,
        multiplierCapped: multiplierCapped,
        perOpponent: perOpponent,
        payerCount: payerCount,
        winnerGain: winnerGain,
        explanation: explanation
    };
}
function $3c7d2d63503f82d3$var$normalizeEvents(huMethod, events, errors, warnings) {
    const normalized = {
        gangShangKaiHua: Boolean(events.gangShangKaiHua),
        gangShangPao: Boolean(events.gangShangPao),
        qiangGangHu: Boolean(events.qiangGangHu),
        haiDi: Boolean(events.haiDi)
    };
    if (huMethod === 'zimo') {
        if (normalized.gangShangPao) errors.push("\u201C\u6760\u4E0A\u70AE\u201D\u53EA\u80FD\u70B9\u70AE");
        if (normalized.qiangGangHu) errors.push("\u201C\u62A2\u6760\u80E1\u201D\u53EA\u80FD\u70B9\u70AE");
    } else {
        if (normalized.gangShangKaiHua) errors.push("\u201C\u6760\u4E0A\u5F00\u82B1\u201D\u53EA\u80FD\u81EA\u6478");
        if (normalized.haiDi) errors.push("\u201C\u6D77\u5E95\u635E\u6708\u201D\u53EA\u80FD\u81EA\u6478");
    }
    if (normalized.gangShangPao && normalized.qiangGangHu) {
        // 按规则：不会同时成立。若同时传入，优先按“抢杠胡”处理（清掉杠上炮）。
        warnings.push("\u201C\u6760\u4E0A\u70AE\u201D\u548C\u201C\u62A2\u6760\u80E1\u201D\u4E0D\u4F1A\u540C\u65F6\u6210\u7ACB\uFF1A\u5DF2\u6309\u201C\u62A2\u6760\u80E1\u201D\u5904\u7406\uFF08\u5FFD\u7565\u6760\u4E0A\u70AE\uFF09\u3002");
        normalized.gangShangPao = false;
    }
    if (normalized.gangShangKaiHua && normalized.haiDi) {
        // 按规则：海底不包含杠后补张，因此不会同时成立。若同时传入，优先按“杠上开花”处理（清掉海底）。
        warnings.push("\u201C\u6760\u4E0A\u5F00\u82B1\u201D\u548C\u201C\u6D77\u5E95\u635E\u6708\u201D\u4E0D\u4F1A\u540C\u65F6\u6210\u7ACB\uFF1A\u5DF2\u6309\u201C\u6760\u4E0A\u5F00\u82B1\u201D\u5904\u7406\uFF08\u5FFD\u7565\u6D77\u5E95\u635E\u6708\uFF09\u3002");
        normalized.haiDi = false;
    }
    return normalized;
}
function $3c7d2d63503f82d3$var$evaluateHand(countsConcealed, melds, info) {
    const concealedCount = countsConcealed.reduce((a, b)=>a + b, 0);
    // 七对：必须无副露
    if (!info.standardOnly && info.meldCount === 0 && concealedCount === 14 && $3c7d2d63503f82d3$var$isSevenPairs(countsConcealed)) {
        const quadCount = $3c7d2d63503f82d3$var$countQuads(countsConcealed);
        const ctx = {
            kind: 'sevenPairs',
            qing: info.suits.size === 1,
            jiang: $3c7d2d63503f82d3$var$isJiang(countsConcealed, new Array(27).fill(0)),
            duanYaoJiu: $3c7d2d63503f82d3$var$isDuanYao(countsConcealed, new Array(27).fill(0)),
            rootCount: quadCount,
            meldCount: 0,
            kongCount: 0,
            quadCount: quadCount
        };
        return {
            ok: true,
            ctx: ctx,
            best: {
                multiplierRaw: $3c7d2d63503f82d3$var$handMultiplier(ctx)
            }
        };
    }
    // 标准形：张数由副露数决定
    const setsNeeded = 4 - info.meldCount;
    if (setsNeeded < 0) return {
        ok: false,
        ctx: null,
        best: null,
        reason: "\u526F\u9732\u8FC7\u591A\uFF08\u6700\u591A 4 \u7EC4\uFF09"
    };
    const expectedConcealed = setsNeeded * 3 + 2;
    if (concealedCount !== expectedConcealed) return {
        ok: false,
        ctx: null,
        best: null,
        reason: "\u6697\u624B\u5F20\u6570\u4E0D\u5339\u914D\uFF08\u9700\u8981\u6309\u526F\u9732\u6570\u586B\u5199\uFF09"
    };
    const meldSets = melds.map((m)=>({
            kind: 'triplet',
            tileKey: m.tileKey
        }));
    const decompositions = $3c7d2d63503f82d3$var$enumerateStandardDecompositions(countsConcealed, setsNeeded);
    if (decompositions.length === 0) return {
        ok: false,
        ctx: null,
        best: null,
        reason: "\u6697\u624B\u65E0\u6CD5\u7EC4\u6210\u6807\u51C6\u80E1\u724C\u7ED3\u6784\uFF084\u7EC4+\u5C06\uFF09"
    };
    const meldCountArr = $3c7d2d63503f82d3$var$meldCounts(melds);
    const jiang = $3c7d2d63503f82d3$var$isJiang(countsConcealed, meldCountArr);
    const duanYaoJiu = $3c7d2d63503f82d3$var$isDuanYao(countsConcealed, meldCountArr);
    let bestCtx = null;
    let bestMult = 0;
    for (const d of decompositions){
        const allSets = [
            ...meldSets,
            ...d.concealedSets
        ];
        const pongpong = allSets.every((s)=>s.kind === 'triplet');
        const yaojiu = $3c7d2d63503f82d3$var$isYaoJiu(allSets, d.pairTileKey);
        const ctx = {
            kind: 'standard',
            qing: info.suits.size === 1,
            jiang: jiang,
            duanYaoJiu: duanYaoJiu,
            rootCount: info.rootCount,
            meldCount: info.meldCount,
            kongCount: info.kongCount,
            pongpong: pongpong,
            yaojiu: yaojiu,
            goldHook: info.meldCount === 4,
            eighteenArhats: info.meldCount === 4 && info.kongCount === 4
        };
        const mult = $3c7d2d63503f82d3$var$handMultiplier(ctx);
        if (mult > bestMult) {
            bestMult = mult;
            bestCtx = ctx;
        }
    }
    if (!bestCtx) return {
        ok: false,
        ctx: null,
        best: null,
        reason: "\u6697\u624B\u65E0\u6CD5\u7EC4\u6210\u6807\u51C6\u80E1\u724C\u7ED3\u6784\uFF084\u7EC4+\u5C06\uFF09"
    };
    return {
        ok: true,
        ctx: bestCtx,
        best: {
            multiplierRaw: bestMult
        }
    };
}
function $3c7d2d63503f82d3$var$handMultiplier(ctx) {
    let mult = 1;
    // 结构番（四选一）：七对 > 金钩钓 > 碰碰胡 > 平胡
    if (ctx.kind === 'sevenPairs') mult *= $3c7d2d63503f82d3$var$FAN_MULT_7PAIRS;
    else if (ctx.goldHook) mult *= $3c7d2d63503f82d3$var$FAN_MULT_GOLD_HOOK;
    else if (ctx.pongpong) mult *= $3c7d2d63503f82d3$var$FAN_MULT_PONGPONG;
    else mult *= $3c7d2d63503f82d3$var$FAN_MULT_PINGHU;
    // 属性番（可叠加）
    if (ctx.qing) mult *= $3c7d2d63503f82d3$var$FAN_MULT_QING;
    if (ctx.kind === 'standard' && ctx.yaojiu) mult *= $3c7d2d63503f82d3$var$FAN_MULT_YAOJIU;
    else if (ctx.jiang) mult *= $3c7d2d63503f82d3$var$FAN_MULT_JIANG;
    else if (ctx.duanYaoJiu) mult *= $3c7d2d63503f82d3$var$FAN_MULT_DUANYAOJIU;
    // 根：2^根数
    if (ctx.rootCount > 0) mult *= Math.pow(2, ctx.rootCount);
    return mult;
}
function $3c7d2d63503f82d3$var$buildEventFans(huMethod, events) {
    const fans = [];
    if (huMethod === 'zimo') {
        fans.push({
            id: 'zimo',
            name: "\u81EA\u6478",
            multiplier: $3c7d2d63503f82d3$var$FAN_MULT_EVENT
        });
        if (events.gangShangKaiHua) fans.push({
            id: 'gangShangKaiHua',
            name: "\u6760\u4E0A\u5F00\u82B1",
            multiplier: $3c7d2d63503f82d3$var$FAN_MULT_EVENT
        });
        if (events.haiDi) fans.push({
            id: 'haiDi',
            name: "\u6D77\u5E95\u635E\u6708",
            multiplier: $3c7d2d63503f82d3$var$FAN_MULT_EVENT
        });
    } else {
        if (events.gangShangPao) fans.push({
            id: 'gangShangPao',
            name: "\u6760\u4E0A\u70AE",
            multiplier: $3c7d2d63503f82d3$var$FAN_MULT_EVENT
        });
        if (events.qiangGangHu) fans.push({
            id: 'qiangGangHu',
            name: "\u62A2\u6760\u80E1",
            multiplier: $3c7d2d63503f82d3$var$FAN_MULT_EVENT
        });
    }
    return fans;
}
function $3c7d2d63503f82d3$var$buildHandFans(ctx) {
    const fans = [];
    // 结构番（四选一）：七对 > 金钩钓 > 碰碰胡 > 平胡
    if (ctx.kind === 'sevenPairs') fans.push({
        id: '7pairs',
        name: "\u4E03\u5BF9",
        multiplier: $3c7d2d63503f82d3$var$FAN_MULT_7PAIRS
    });
    else if (ctx.goldHook) fans.push({
        id: 'goldHook',
        name: "\u91D1\u94A9\u9493",
        multiplier: $3c7d2d63503f82d3$var$FAN_MULT_GOLD_HOOK
    });
    else if (ctx.pongpong) fans.push({
        id: 'pongpong',
        name: "\u78B0\u78B0\u80E1",
        multiplier: $3c7d2d63503f82d3$var$FAN_MULT_PONGPONG
    });
    else fans.push({
        id: 'pinghu',
        name: "\u5E73\u80E1",
        multiplier: $3c7d2d63503f82d3$var$FAN_MULT_PINGHU
    });
    // 属性番（可叠加）
    if (ctx.qing) fans.push({
        id: 'qingYiSe',
        name: "\u6E05\u4E00\u8272",
        multiplier: $3c7d2d63503f82d3$var$FAN_MULT_QING
    });
    if (ctx.kind === 'standard' && ctx.yaojiu) fans.push({
        id: 'yaojiu',
        name: "\u5E7A\u4E5D",
        multiplier: $3c7d2d63503f82d3$var$FAN_MULT_YAOJIU
    });
    else if (ctx.jiang) fans.push({
        id: 'jiang',
        name: "\u5C06",
        multiplier: $3c7d2d63503f82d3$var$FAN_MULT_JIANG
    });
    else if (ctx.duanYaoJiu) fans.push({
        id: 'duanYaoJiu',
        name: "\u65AD\u5E7A\u4E5D",
        multiplier: $3c7d2d63503f82d3$var$FAN_MULT_DUANYAOJIU
    });
    // 根：2^根数（根与杠豆互不影响）
    if (ctx.rootCount > 0) fans.push({
        id: 'root',
        name: `${ctx.rootCount}\u{6839}`,
        multiplier: Math.pow(2, ctx.rootCount)
    });
    return fans;
}
function $3c7d2d63503f82d3$var$emptyResult(ok, errors, warnings) {
    return {
        ok: ok,
        errors: errors,
        warnings: warnings,
        fans: [],
        multiplierRaw: 0,
        multiplierCapped: 0,
        perOpponent: 0,
        payerCount: 0,
        winnerGain: 0,
        explanation: []
    };
}
function $3c7d2d63503f82d3$var$buildExplanation(params) {
    const parts = params.fans.map((f)=>`${f.name}\xd7${f.multiplier}`);
    const lines = [];
    if (parts.length > 0) lines.push(`\u{500D}\u{6570} = ${parts.join(" \xd7 ")}`);
    if (params.cap !== null && params.multiplierRaw !== params.multiplierCapped) lines.push(`\u{5C01}\u{9876}\u{FF1A}min(${params.multiplierRaw}, ${params.cap}) = ${params.multiplierCapped}`);
    else lines.push(`\u{5408}\u{8BA1}\u{500D}\u{6570} = ${params.multiplierCapped}`);
    lines.push(`\u{5355}\u{5BB6}\u{5E94}\u{4ED8} = ${params.base} \xd7 ${params.multiplierCapped} = ${params.perOpponent}`);
    if (params.huMethod === 'zimo') lines.push(`\u{81EA}\u{6478}\u{FF08}\u{5269}\u{4F59}${params.payerCount}\u{5BB6}\u{FF09}\u{FF1A}\u{603B}\u{5F97}\u{5206} = ${params.perOpponent} \xd7 ${params.payerCount} = ${params.winnerGain}`);
    else lines.push(`\u{70B9}\u{70AE}\u{FF1A}\u{603B}\u{5F97}\u{5206} = ${params.perOpponent} \xd7 1 = ${params.winnerGain}`);
    return lines;
}
function $3c7d2d63503f82d3$var$suitsUsed(counts) {
    const s = new Set();
    for(let i = 0; i < 27; i++)if (counts[i] > 0) s.add((0, $fJUxr.suitOf)(i));
    return s;
}
function $3c7d2d63503f82d3$var$tileKeyHint(tileKey) {
    const r = (0, $fJUxr.rankOf)(tileKey);
    const suit = (0, $fJUxr.suitOf)(tileKey);
    const suitText = suit === 'm' ? "\u4E07" : suit === 'p' ? "\u7B52" : "\u6761";
    return `${r}${suitText}`;
}
function $3c7d2d63503f82d3$var$countRoots(counts) {
    let roots = 0;
    for(let i = 0; i < 27; i++)if (counts[i] === 4) roots += 1;
    return roots;
}
function $3c7d2d63503f82d3$var$countQuads(counts) {
    let q = 0;
    for(let i = 0; i < 27; i++)if (counts[i] === 4) q += 1;
    return q;
}
function $3c7d2d63503f82d3$var$isSevenPairs(counts) {
    let pairs = 0;
    for(let i = 0; i < counts.length; i++){
        const c = counts[i];
        if (c === 0) continue;
        if (c === 2) pairs += 1;
        else if (c === 4) pairs += 2;
        else return false;
    }
    return pairs === 7;
}
function $3c7d2d63503f82d3$var$enumerateStandardDecompositions(counts, setsNeeded) {
    const buf = counts.slice();
    const out = [];
    for(let i = 0; i < buf.length; i++){
        if (buf[i] < 2) continue;
        buf[i] -= 2;
        const setsLists = $3c7d2d63503f82d3$var$enumerateSets(buf, setsNeeded);
        for (const sets of setsLists)out.push({
            pairTileKey: i,
            concealedSets: sets
        });
        buf[i] += 2;
    }
    return out;
}
function $3c7d2d63503f82d3$var$enumerateSets(counts, setsNeeded) {
    if (setsNeeded === 0) return counts.every((c)=>c === 0) ? [
        []
    ] : [];
    let first = 0;
    while(first < counts.length && counts[first] === 0)first++;
    if (first >= counts.length) return [];
    const results = [];
    // Triplet
    if (counts[first] >= 3) {
        counts[first] -= 3;
        for (const rest of $3c7d2d63503f82d3$var$enumerateSets(counts, setsNeeded - 1))results.push([
            {
                kind: 'triplet',
                tileKey: first
            },
            ...rest
        ]);
        counts[first] += 3;
    }
    // Sequence (same suit, rank <= 7)
    const r = first % 9;
    if (r <= 6) {
        const i1 = first + 1;
        const i2 = first + 2;
        if (counts[i1] > 0 && counts[i2] > 0) {
            counts[first] -= 1;
            counts[i1] -= 1;
            counts[i2] -= 1;
            for (const rest of $3c7d2d63503f82d3$var$enumerateSets(counts, setsNeeded - 1))results.push([
                {
                    kind: 'sequence',
                    startTileKey: first
                },
                ...rest
            ]);
            counts[first] += 1;
            counts[i1] += 1;
            counts[i2] += 1;
        }
    }
    return results;
}
function $3c7d2d63503f82d3$var$isYaoJiu(sets, pairTileKey) {
    const pairRank = (0, $fJUxr.rankOf)(pairTileKey);
    if (pairRank !== 1 && pairRank !== 9) return false;
    for (const s of sets)if (s.kind === 'triplet') {
        const r = (0, $fJUxr.rankOf)(s.tileKey);
        if (r !== 1 && r !== 9) return false;
    } else {
        const start = (0, $fJUxr.rankOf)(s.startTileKey);
        if (start !== 1 && start !== 7) return false;
    }
    return true;
}
function $3c7d2d63503f82d3$var$isDuanYao(countsConcealed, countsMeld) {
    for(let i = 0; i < 27; i++){
        const total = countsConcealed[i] + countsMeld[i];
        if (total === 0) continue;
        const r = (0, $fJUxr.rankOf)(i);
        if (r === 1 || r === 9) return false;
    }
    return true;
}
function $3c7d2d63503f82d3$var$isJiang(countsConcealed, countsMeld) {
    for(let i = 0; i < 27; i++){
        const total = countsConcealed[i] + countsMeld[i];
        if (total === 0) continue;
        const r = (0, $fJUxr.rankOf)(i);
        if (r !== 2 && r !== 5 && r !== 8) return false;
    }
    return true;
}
function $3c7d2d63503f82d3$var$meldCounts(melds) {
    const c = new Array(27).fill(0);
    for (const m of melds)c[m.tileKey] += m.kind === 'gang' ? 4 : 3;
    return c;
}

});


var $bBXum = parcelRequire("bBXum");

var $1TSFl = parcelRequire("1TSFl");

var $KfYa1 = parcelRequire("KfYa1");

var $5TMGJ = parcelRequire("5TMGJ");

var $9wRj8 = parcelRequire("9wRj8");

var $iRbTC = parcelRequire("iRbTC");

var $j0QBl = parcelRequire("j0QBl");

var $8PAWz = parcelRequire("8PAWz");
(0, $9wRj8.ensurePwaManifestLink)();
class $0073ed07eb3af726$var$NullObjectView {
    replaceThings(_params) {}
    replaceShadows(_places) {}
    updateScores(_scores) {}
    updateThings(_things) {}
    updateDropShadows(_places) {}
}
class $0073ed07eb3af726$var$NullSoundPlayer {
    play(_type, _side) {}
}
function $0073ed07eb3af726$var$el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
}
async function $0073ed07eb3af726$var$copyToClipboard(text) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch  {
        // fallback
        try {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(textarea);
            return ok;
        } catch  {
            return false;
        }
    }
}
const $0073ed07eb3af726$var$A2HS_DISMISS_KEY = 'mjlab_a2hs_dismissed_v1';
function $0073ed07eb3af726$var$isStandaloneMode() {
    const anyNav = navigator;
    if (typeof window.matchMedia === 'function') try {
        if (window.matchMedia('(display-mode: standalone)').matches) return true;
    } catch  {
    // ignore
    }
    return anyNav?.standalone === true;
}
function $0073ed07eb3af726$var$isIosDevice() {
    const ua = navigator.userAgent ?? '';
    const isIpadDesktopUa = /Macintosh/i.test(ua) && (navigator.maxTouchPoints ?? 0) > 1;
    return /iPhone|iPad|iPod/i.test(ua) || isIpadDesktopUa;
}
function $0073ed07eb3af726$var$shouldShowA2hsTip() {
    if (!$0073ed07eb3af726$var$isIosDevice()) return false;
    if ($0073ed07eb3af726$var$isStandaloneMode()) return false;
    try {
        return localStorage.getItem($0073ed07eb3af726$var$A2HS_DISMISS_KEY) !== '1';
    } catch  {
        return true;
    }
}
function $0073ed07eb3af726$var$dismissA2hsTip() {
    try {
        localStorage.setItem($0073ed07eb3af726$var$A2HS_DISMISS_KEY, '1');
    } catch  {
    // ignore
    }
}
function $0073ed07eb3af726$var$buildUi(root) {
    root.innerHTML = '';
    if ($0073ed07eb3af726$var$shouldShowA2hsTip()) {
        const card = $0073ed07eb3af726$var$el('div', 'alert alert-warning text-dark small mb-3', '');
        const title = $0073ed07eb3af726$var$el('div', 'font-weight-bold', "iPhone \u5EFA\u8BAE\u201C\u6DFB\u52A0\u5230\u4E3B\u5C4F\u5E55\u201D\u83B7\u5F97\u66F4\u6C89\u6D78\uFF08\u8FD1\u5168\u5C4F\uFF09\u4F53\u9A8C");
        card.appendChild(title);
        card.appendChild($0073ed07eb3af726$var$el('div', 'mt-1', "\u64CD\u4F5C\uFF1A\u70B9\u51FB\u6D4F\u89C8\u5668\u201C\u5206\u4EAB/\u83DC\u5355\u201D \u2192 \u201C\u6DFB\u52A0\u5230\u4E3B\u5C4F\u5E55\u201D\uFF0C\u7136\u540E\u4ECE\u684C\u9762\u56FE\u6807\u8FDB\u5165\u3002"));
        const actions = $0073ed07eb3af726$var$el('div', 'mt-2', '');
        const dismissBtn = $0073ed07eb3af726$var$el('button', 'btn btn-sm btn-outline-dark', "\u4E0D\u518D\u63D0\u793A");
        dismissBtn.type = 'button';
        dismissBtn.onclick = ()=>{
            $0073ed07eb3af726$var$dismissA2hsTip();
            card.remove();
        };
        actions.appendChild(dismissBtn);
        card.appendChild(actions);
        root.appendChild(card);
    }
    root.appendChild($0073ed07eb3af726$var$el('h4', 'mb-3', "\u521B\u5EFA\u623F\u95F4\uFF08\u79FB\u52A8\u7AEF\uFF09"));
    const waitMode = $0073ed07eb3af726$var$el('select', 'form-control form-control-sm dark-select mb-2');
    waitMode.appendChild(new Option("\u7B49\u5F85\u6A21\u5F0F\uFF1A\u73A9\u5BB6\u70B9\u51FB\u8FC7\uFF08\u4E0D\u9650\u65F6\uFF09", 'noTimeout', true, true));
    waitMode.appendChild(new Option("\u7B49\u5F85\u6A21\u5F0F\uFF1A\u53EA\u8D85\u65F6\u81EA\u52A8\uFF086 \u5206\u949F\uFF09", 'timeoutAuto'));
    root.appendChild(waitMode);
    const create = $0073ed07eb3af726$var$el('button', 'btn btn-warning text-dark w-100', "\u521B\u5EFA\u623F\u95F4");
    root.appendChild(create);
    const status = $0073ed07eb3af726$var$el('div', 'mt-3 text-white-50', '');
    root.appendChild(status);
    const roomBlock = $0073ed07eb3af726$var$el('div', 'mt-3', '');
    roomBlock.style.display = 'none';
    root.appendChild(roomBlock);
    const gameIdLine = $0073ed07eb3af726$var$el('div', 'mb-2', '');
    gameIdLine.appendChild($0073ed07eb3af726$var$el('span', 'text-white-50 mr-2', "\u623F\u95F4\u53F7:"));
    const gameId = $0073ed07eb3af726$var$el('span', 'text-light font-weight-bold', '-');
    gameIdLine.appendChild(gameId);
    roomBlock.appendChild(gameIdLine);
    const shareRow = $0073ed07eb3af726$var$el('div', 'input-group mb-2', '');
    const sharePath = $0073ed07eb3af726$var$el('input', 'form-control', '');
    sharePath.readOnly = true;
    const copy = $0073ed07eb3af726$var$el('button', 'btn btn-outline-light', "\u590D\u5236\u94FE\u63A5");
    const append = $0073ed07eb3af726$var$el('div', 'input-group-append', '');
    append.appendChild(copy);
    shareRow.appendChild(sharePath);
    shareRow.appendChild(append);
    roomBlock.appendChild(shareRow);
    const controls = $0073ed07eb3af726$var$el('div', 'mt-4', '');
    controls.style.display = 'none';
    roomBlock.appendChild(controls);
    controls.appendChild($0073ed07eb3af726$var$el('h5', 'mb-2', "\u5BF9\u5C40 + \u8BBE\u7F6E\uFF08\u4EC5\u623F\u4E3B\uFF09"));
    const selects = $0073ed07eb3af726$var$el('div', 'row', '');
    controls.appendChild(selects);
    const col = (label, control)=>{
        const c = $0073ed07eb3af726$var$el('div', 'col-6 mb-2', '');
        c.appendChild($0073ed07eb3af726$var$el('div', 'text-white-50 small mb-1', label));
        c.appendChild(control);
        return c;
    };
    const dealType = $0073ed07eb3af726$var$el('select', 'form-control form-control-sm dark-select');
    dealType.appendChild(new Option('Deal: Hands', (0, $KfYa1.DealType).HANDS, true, true));
    dealType.appendChild(new Option('Deal: Only walls', (0, $KfYa1.DealType).INITIAL));
    dealType.appendChild(new Option('Deal: Winds', (0, $KfYa1.DealType).WINDS));
    dealType.appendChild(new Option('Deal: Only walls (not shuffled)', (0, $KfYa1.DealType).UNSHUFFLED));
    const gameType = $0073ed07eb3af726$var$el('select', 'form-control form-control-sm dark-select');
    gameType.appendChild(new Option("\u8840\u6218\u5230\u5E95", (0, $KfYa1.GameType).BLOOD_BATTLE, true, true));
    gameType.appendChild(new Option('4-player', (0, $KfYa1.GameType).FOUR_PLAYER));
    gameType.appendChild(new Option('3-player', (0, $KfYa1.GameType).THREE_PLAYER));
    gameType.appendChild(new Option('2-player Minefield', (0, $KfYa1.GameType).MINEFIELD));
    gameType.appendChild(new Option('2-player Bamboo', (0, $KfYa1.GameType).BAMBOO));
    gameType.appendChild(new Option('Demo', (0, $KfYa1.GameType).FOUR_PLAYER_DEMO));
    const fives = $0073ed07eb3af726$var$el('select', 'form-control form-control-sm dark-select');
    fives.appendChild(new Option('No red fives', '000'));
    fives.appendChild(new Option('1-1-1', '111', true, true));
    fives.appendChild(new Option('1-2-1', '121'));
    const points = $0073ed07eb3af726$var$el('select', 'form-control form-control-sm dark-select');
    points.appendChild(new Option('25k', '25', true, true));
    points.appendChild(new Option('30k', '30'));
    points.appendChild(new Option('35k', '35'));
    points.appendChild(new Option('40k', '40'));
    points.appendChild(new Option('100k', '100'));
    selects.appendChild(col('Deal', dealType));
    selects.appendChild(col('Game type', gameType));
    selects.appendChild(col('Red fives', fives));
    selects.appendChild(col('Starting points', points));
    const btnRow1 = $0073ed07eb3af726$var$el('div', 'd-flex gap-2 mt-2', '');
    btnRow1.style.gap = '8px';
    const deal = $0073ed07eb3af726$var$el('button', 'btn btn-warning text-dark w-100', 'Deal');
    const resetPoints = $0073ed07eb3af726$var$el('button', 'btn btn-outline-light w-100', 'Reset points');
    btnRow1.appendChild(deal);
    btnRow1.appendChild(resetPoints);
    controls.appendChild(btnRow1);
    const btnRow2 = $0073ed07eb3af726$var$el('div', 'd-flex gap-2 mt-2', '');
    btnRow2.style.gap = '8px';
    const toggleDealer = $0073ed07eb3af726$var$el('button', 'btn btn-outline-light w-100', 'Dealer +1');
    const toggleHonba = $0073ed07eb3af726$var$el('button', 'btn btn-outline-light w-100', 'Honba +1');
    btnRow2.appendChild(toggleDealer);
    btnRow2.appendChild(toggleHonba);
    controls.appendChild(btnRow2);
    return {
        create: create,
        status: status,
        waitMode: waitMode,
        roomBlock: roomBlock,
        gameId: gameId,
        sharePath: sharePath,
        copy: copy,
        controls: controls,
        deal: deal,
        resetPoints: resetPoints,
        toggleDealer: toggleDealer,
        toggleHonba: toggleHonba,
        dealType: dealType,
        gameType: gameType,
        fives: fives,
        points: points
    };
}
function $0073ed07eb3af726$var$updateDealVisibility(elements) {
    const gameType = elements.gameType.value;
    for (const option of Array.from(elements.dealType.options)){
        const dealType = option.value;
        option.hidden = (0, $5TMGJ.DEALS)[gameType][dealType] === undefined;
    }
    if ((0, $5TMGJ.DEALS)[gameType][elements.dealType.value] === undefined) {
        const first = Array.from(elements.dealType.options).find((o)=>!o.hidden);
        if (first) elements.dealType.value = first.value;
    }
    // 血战到底：固定 108 张序数牌，不使用红五/点棒设置
    const blood = gameType === (0, $KfYa1.GameType).BLOOD_BATTLE;
    elements.fives.disabled = blood;
    elements.points.disabled = blood;
    if (blood) {
        elements.fives.value = '000';
        elements.points.value = (0, $KfYa1.GAME_TYPES)[gameType].points;
    }
}
function $0073ed07eb3af726$var$setControlsEnabled(elements, enabled) {
    const controls = [
        elements.deal,
        elements.resetPoints,
        elements.toggleDealer,
        elements.toggleHonba,
        elements.dealType,
        elements.gameType,
        elements.fives,
        elements.points
    ];
    for (const c of controls)c.disabled = !enabled;
}
const $0073ed07eb3af726$var$root = document.getElementById('mobile-root');
const $0073ed07eb3af726$var$elements = $0073ed07eb3af726$var$buildUi($0073ed07eb3af726$var$root);
let $0073ed07eb3af726$var$client = null;
let $0073ed07eb3af726$var$world = null;
let $0073ed07eb3af726$var$wantFriendConfig = null;
let $0073ed07eb3af726$var$insufficientRedirectTimeoutId = null;
let $0073ed07eb3af726$var$insufficientRedirectIntervalId = null;
function $0073ed07eb3af726$var$waitModeLabel(mode) {
    return mode === 'timeoutAuto' ? "\u53EA\u8D85\u65F6\u81EA\u52A8\uFF086 \u5206\u949F\uFF09" : "\u73A9\u5BB6\u70B9\u51FB\u8FC7\uFF08\u4E0D\u9650\u65F6\uFF09";
}
function $0073ed07eb3af726$var$clearInsufficientRedirectTimers() {
    if ($0073ed07eb3af726$var$insufficientRedirectTimeoutId !== null) {
        window.clearTimeout($0073ed07eb3af726$var$insufficientRedirectTimeoutId);
        $0073ed07eb3af726$var$insufficientRedirectTimeoutId = null;
    }
    if ($0073ed07eb3af726$var$insufficientRedirectIntervalId !== null) {
        window.clearInterval($0073ed07eb3af726$var$insufficientRedirectIntervalId);
        $0073ed07eb3af726$var$insufficientRedirectIntervalId = null;
    }
}
function $0073ed07eb3af726$var$getPersonalCenterUrl() {
    return `${(0, $iRbTC.getBasePath)()}me/`;
}
function $0073ed07eb3af726$var$normalizeActiveGame(raw) {
    const gameId = typeof raw?.gameId === 'string' ? raw.gameId.trim() : '';
    if (!gameId) return null;
    const seatRaw = Number(raw?.seat);
    const seat = Number.isFinite(seatRaw) ? Math.trunc(seatRaw) : -1;
    if (seat < 0 || seat > 3) return null;
    const roomType = typeof raw?.roomType === 'string' ? raw.roomType.trim() || null : null;
    return {
        gameId: gameId,
        seat: seat,
        roomType: roomType
    };
}
function $0073ed07eb3af726$var$modeLabelOfActiveGame(active) {
    if (active.roomType === 'newbie') return "\u65B0\u624B\u623F";
    if (active.roomType === 'practice-branch') return "\u7EC3\u4E60\u5206\u652F";
    return "\u597D\u53CB\u623F";
}
function $0073ed07eb3af726$var$activeGameUrl(active) {
    const basePath = (0, $iRbTC.getBasePath)();
    const room = active.roomType === 'newbie' ? '&room=newbie' : '';
    return `${basePath}hand/?gameId=${encodeURIComponent(active.gameId)}${room}`;
}
function $0073ed07eb3af726$var$showActiveGameGuard(active, onAbandonAndContinue) {
    $0073ed07eb3af726$var$clearInsufficientRedirectTimers();
    $0073ed07eb3af726$var$elements.status.innerHTML = '';
    const msg = document.createElement('div');
    msg.textContent = `\u{4F60}\u{5DF2}\u{6709}\u{8FDB}\u{884C}\u{4E2D}\u{7684}${$0073ed07eb3af726$var$modeLabelOfActiveGame(active)}\u{FF08}\u{5EA7}\u{4F4D} ${active.seat + 1}\u{FF09}\u{FF0C}\u{6682}\u{4E0D}\u{5141}\u{8BB8}\u{65B0}\u{5F00}\u{623F}\u{95F4}\u{3002}`;
    $0073ed07eb3af726$var$elements.status.appendChild(msg);
    const row = document.createElement('div');
    row.className = 'mt-2';
    const continueBtn = document.createElement('button');
    continueBtn.className = 'btn btn-warning btn-sm text-dark';
    continueBtn.type = 'button';
    continueBtn.textContent = "\u7EE7\u7EED\u65E7\u724C\u5C40\uFF08\u63A8\u8350\uFF09";
    continueBtn.onclick = ()=>{
        window.location.href = $0073ed07eb3af726$var$activeGameUrl(active);
    };
    row.appendChild(continueBtn);
    const abandonBtn = document.createElement('button');
    abandonBtn.className = 'btn btn-outline-light btn-sm ms-2';
    abandonBtn.type = 'button';
    abandonBtn.textContent = "\u653E\u5F03\u65E7\u724C\u5C40\u5E76\u65B0\u5F00";
    let abandoning = false;
    abandonBtn.onclick = async ()=>{
        if (abandoning) return;
        abandoning = true;
        continueBtn.disabled = true;
        abandonBtn.disabled = true;
        abandonBtn.textContent = "\u5904\u7406\u4E2D...";
        try {
            const out = await (0, $8PAWz.abandonActiveGame)(active.gameId);
            const remaining = $0073ed07eb3af726$var$normalizeActiveGame(out?.remainingActiveGame);
            if (remaining) {
                abandoning = false;
                $0073ed07eb3af726$var$showActiveGameGuard(remaining, onAbandonAndContinue);
                return;
            }
            $0073ed07eb3af726$var$elements.status.textContent = "\u5DF2\u653E\u5F03\u65E7\u724C\u5C40\uFF0C\u6B63\u5728\u7EE7\u7EED\u65B0\u5F00\u6D41\u7A0B\u2026";
            if (onAbandonAndContinue) await onAbandonAndContinue();
        } catch (err) {
            $0073ed07eb3af726$var$elements.status.textContent = `\u{653E}\u{5F03}\u{65E7}\u{724C}\u{5C40}\u{5931}\u{8D25}\u{FF1A}${String(err?.message ?? err)}`;
            continueBtn.disabled = false;
            abandonBtn.disabled = false;
            abandonBtn.textContent = "\u653E\u5F03\u65E7\u724C\u5C40\u5E76\u65B0\u5F00";
            abandoning = false;
            return;
        }
        abandoning = false;
    };
    row.appendChild(abandonBtn);
    $0073ed07eb3af726$var$elements.status.appendChild(row);
}
function $0073ed07eb3af726$var$showInsufficientStatusAndRedirect(params) {
    $0073ed07eb3af726$var$clearInsufficientRedirectTimers();
    let remain = 3;
    const amount = Math.max(0, Math.trunc(params.dailyClaimAmount ?? 4000));
    const text = params.canClaimDaily ? `\u{5BF9}\u{5C40}\u{79EF}\u{5206}\u{4E0D}\u{8DB3}\u{3002}\u{4ECA}\u{65E5}\u{53EF}\u{9886}\u{53D6} ${amount} \u{5BF9}\u{5C40}\u{79EF}\u{5206}\u{FF0C}3 \u{79D2}\u{540E}\u{5C06}\u{8DF3}\u{8F6C}\u{4E2A}\u{4EBA}\u{4E2D}\u{5FC3}\u{3002}` : "\u5BF9\u5C40\u79EF\u5206\u4E0D\u8DB3\u3002\u4ECA\u65E5\u9886\u53D6\u6B21\u6570\u5DF2\u7528\u5B8C\uFF0C3 \u79D2\u540E\u5C06\u8DF3\u8F6C\u4E2A\u4EBA\u4E2D\u5FC3\u3002";
    $0073ed07eb3af726$var$elements.status.innerHTML = '';
    const msg = document.createElement('div');
    msg.textContent = text;
    $0073ed07eb3af726$var$elements.status.appendChild(msg);
    const countdown = document.createElement('div');
    countdown.style.marginTop = '6px';
    const renderCountdown = ()=>{
        countdown.textContent = `${remain} \u{79D2}\u{540E}\u{81EA}\u{52A8}\u{8DF3}\u{8F6C}\u{5230}\u{4E2A}\u{4EBA}\u{4E2D}\u{5FC3}\u{3002}`;
    };
    renderCountdown();
    $0073ed07eb3af726$var$elements.status.appendChild(countdown);
    const goNowBtn = document.createElement('button');
    goNowBtn.className = 'btn btn-outline-light btn-sm mt-2';
    goNowBtn.type = 'button';
    goNowBtn.textContent = "\u7ACB\u5373\u524D\u5F80\u4E2A\u4EBA\u4E2D\u5FC3";
    goNowBtn.onclick = ()=>{
        $0073ed07eb3af726$var$clearInsufficientRedirectTimers();
        window.location.href = $0073ed07eb3af726$var$getPersonalCenterUrl();
    };
    $0073ed07eb3af726$var$elements.status.appendChild(goNowBtn);
    $0073ed07eb3af726$var$insufficientRedirectTimeoutId = window.setTimeout(()=>{
        $0073ed07eb3af726$var$clearInsufficientRedirectTimers();
        window.location.href = $0073ed07eb3af726$var$getPersonalCenterUrl();
    }, 3000);
    $0073ed07eb3af726$var$insufficientRedirectIntervalId = window.setInterval(()=>{
        remain -= 1;
        if (remain <= 0) {
            $0073ed07eb3af726$var$clearInsufficientRedirectTimers();
            return;
        }
        renderCountdown();
    }, 1000);
}
$0073ed07eb3af726$var$elements.gameType.onchange = ()=>{
    $0073ed07eb3af726$var$updateDealVisibility($0073ed07eb3af726$var$elements);
    const gameType = $0073ed07eb3af726$var$elements.gameType.value;
    $0073ed07eb3af726$var$elements.points.value = (0, $KfYa1.GAME_TYPES)[gameType].points;
};
$0073ed07eb3af726$var$elements.dealType.onchange = ()=>$0073ed07eb3af726$var$updateDealVisibility($0073ed07eb3af726$var$elements);
$0073ed07eb3af726$var$updateDealVisibility($0073ed07eb3af726$var$elements);
const $0073ed07eb3af726$var$createRoom = async ()=>{
    if ($0073ed07eb3af726$var$client?.connected()) return;
    $0073ed07eb3af726$var$clearInsufficientRedirectTimers();
    let hostStartBeans = 0;
    try {
        await (0, $8PAWz.ensureUser)();
        const pointsInfo = await (0, $8PAWz.fetchMatchPointsInfo)();
        hostStartBeans = Math.max(0, Math.trunc(pointsInfo.matchPoints ?? 0));
        if (hostStartBeans <= 0) {
            $0073ed07eb3af726$var$showInsufficientStatusAndRedirect({
                canClaimDaily: !!pointsInfo.canClaimDaily,
                dailyClaimAmount: Math.max(0, Math.trunc(pointsInfo.dailyClaimAmount ?? 4000))
            });
            return;
        }
        try {
            const active = $0073ed07eb3af726$var$normalizeActiveGame((await (0, $8PAWz.fetchActiveGame)()).activeGame);
            if (active) {
                $0073ed07eb3af726$var$showActiveGameGuard(active, async ()=>{
                    await $0073ed07eb3af726$var$createRoom();
                });
                return;
            }
        } catch  {
        // ignore
        }
    } catch  {
        $0073ed07eb3af726$var$elements.status.textContent = "\u8D26\u53F7\u6821\u9A8C\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002";
        return;
    }
    $0073ed07eb3af726$var$elements.waitMode.disabled = true;
    $0073ed07eb3af726$var$elements.status.textContent = "\u6B63\u5728\u521B\u5EFA\u623F\u95F4\u5E76\u8FDE\u63A5\u670D\u52A1\u5668\u2026";
    $0073ed07eb3af726$var$elements.create.disabled = true;
    $0073ed07eb3af726$var$wantFriendConfig = {
        waitMode: $0073ed07eb3af726$var$elements.waitMode.value === 'timeoutAuto' ? 'timeoutAuto' : 'noTimeout',
        timeoutMs: $0073ed07eb3af726$var$elements.waitMode.value === 'timeoutAuto' ? 360000 : null
    };
    $0073ed07eb3af726$var$client = new (0, $bBXum.Client)();
    $0073ed07eb3af726$var$world = new (0, $1TSFl.World)(new $0073ed07eb3af726$var$NullObjectView(), new $0073ed07eb3af726$var$NullSoundPlayer(), $0073ed07eb3af726$var$client);
    $0073ed07eb3af726$var$client.on('connect', (game, isFirst)=>{
        // Sync nickname/avatar from user profile (if logged in on this device).
        (0, $j0QBl.syncProfileToGameClient)($0073ed07eb3af726$var$client);
        // 预占 seat=0，保证房主恒为 seat0
        $0073ed07eb3af726$var$client.seats.set($0073ed07eb3af726$var$client.playerId(), {
            seat: 0
        });
        const basePath = (0, $iRbTC.getBasePath)();
        const path = `${basePath}hand/?gameId=${game.gameId}`;
        const fullUrl = new URL(path, window.location.origin).toString();
        $0073ed07eb3af726$var$elements.roomBlock.style.display = 'block';
        const authoritative = $0073ed07eb3af726$var$client.isAuthoritative();
        $0073ed07eb3af726$var$elements.controls.style.display = authoritative ? 'none' : 'block';
        $0073ed07eb3af726$var$elements.gameId.textContent = game.gameId;
        $0073ed07eb3af726$var$elements.sharePath.value = path;
        $0073ed07eb3af726$var$elements.status.textContent = authoritative ? `\u{5DF2}\u{521B}\u{5EFA}\u{623F}\u{95F4}\u{FF08}\u{670D}\u{52A1}\u{7AEF}\u{6743}\u{5A01}\u{6A21}\u{5F0F}\u{FF09}\u{3002}\u{7B49}\u{5F85}\u{6A21}\u{5F0F}\u{5DF2}\u{751F}\u{6548}\u{FF1A}${$0073ed07eb3af726$var$waitModeLabel($0073ed07eb3af726$var$wantFriendConfig?.waitMode)}\u{3002}\u{5206}\u{4EAB}\u{94FE}\u{63A5}\u{7ED9}\u{5176}\u{4ED6}\u{73A9}\u{5BB6}\u{8FDB}\u{5165} /hand/\u{3002}` : "\u5DF2\u521B\u5EFA\u623F\u95F4\u3002\u5206\u4EAB\u94FE\u63A5\u7ED9\u5176\u4ED6\u73A9\u5BB6\u8FDB\u5165 /hand/\u3002";
        $0073ed07eb3af726$var$elements.copy.onclick = async ()=>{
            const ok = await $0073ed07eb3af726$var$copyToClipboard(fullUrl);
            $0073ed07eb3af726$var$elements.status.textContent = ok ? "\u5DF2\u590D\u5236\u94FE\u63A5\u3002" : "\u590D\u5236\u5931\u8D25\uFF0C\u8BF7\u624B\u52A8\u590D\u5236\u3002";
        };
        // 创建房间后自动发一局（默认 Hands）
        if (isFirst && $0073ed07eb3af726$var$world && !$0073ed07eb3af726$var$client.isAuthoritative()) {
            const dealType = (0, $KfYa1.DealType).HANDS;
            const gameType = $0073ed07eb3af726$var$elements.gameType.value;
            const fives = gameType === (0, $KfYa1.GameType).BLOOD_BATTLE ? '000' : $0073ed07eb3af726$var$elements.fives.value;
            const points = $0073ed07eb3af726$var$elements.points.value;
            $0073ed07eb3af726$var$world.deal(dealType, gameType, fives, points);
            if (gameType === (0, $KfYa1.GameType).BLOOD_BATTLE) {
                const startBySeat = {
                    0: hostStartBeans,
                    1: 0,
                    2: 0,
                    3: 0
                };
                for (const [pid, seatInfo] of $0073ed07eb3af726$var$client.seats.entries()){
                    const seat = seatInfo?.seat ?? null;
                    if (seat === null || seat === undefined) continue;
                    if (seat < 0 || seat > 3) continue;
                    const raw = seatInfo?.startBeans;
                    const beans = Number.isFinite(raw) ? Math.max(0, Math.trunc(raw)) : null;
                    if (beans === null) continue;
                    startBySeat[seat] = beans;
                }
                const emptyPlayer = (seat, playerId)=>({
                        seat: seat,
                        playerId: playerId,
                        dingque: null,
                        hu: false,
                        huTileKey: null,
                        huSource: null,
                        beans: startBySeat[seat] ?? 0,
                        kongGain: 0,
                        melds: []
                    });
                const swapDirs = [
                    'cw',
                    'ccw',
                    'across'
                ];
                const swapDir = swapDirs[Math.floor(Math.random() * swapDirs.length)] ?? 'cw';
                const state = {
                    version: 1,
                    base: 400,
                    initialBeans: startBySeat[0] ?? 0,
                    initialBeansBySeat: startBySeat,
                    phase: 'swap3',
                    dealer: 0,
                    turnSeat: 0,
                    turnStep: 'discard',
                    wallOrder: [],
                    wallIndex: 0,
                    nextId: 1,
                    pending: null,
                    swap3: {
                        dir: swapDir,
                        since: Date.now(),
                        animatingSince: null,
                        selections: {
                            0: null,
                            1: null,
                            2: null,
                            3: null
                        }
                    },
                    ledger: [],
                    players: {
                        0: emptyPlayer(0, $0073ed07eb3af726$var$client.playerId()),
                        1: emptyPlayer(1, null),
                        2: emptyPlayer(2, null),
                        3: emptyPlayer(3, null)
                    },
                    revealAllHands: false,
                    settlingSince: null
                };
                $0073ed07eb3af726$var$client.blood.set(0, state);
            }
        }
    });
    $0073ed07eb3af726$var$client.on('disconnect', ()=>{
        $0073ed07eb3af726$var$elements.status.textContent = "\u8FDE\u63A5\u5DF2\u65AD\u5F00\u3002\u8BF7\u5237\u65B0\u6216\u91CD\u65B0\u521B\u5EFA\u623F\u95F4\u3002";
        $0073ed07eb3af726$var$elements.waitMode.disabled = false;
        $0073ed07eb3af726$var$setControlsEnabled($0073ed07eb3af726$var$elements, false);
    });
    $0073ed07eb3af726$var$client.on('friendConfigSetAck', (ack)=>{
        if (!$0073ed07eb3af726$var$client || !$0073ed07eb3af726$var$client.connected()) return;
        if (!ack.ok) {
            $0073ed07eb3af726$var$elements.status.textContent = `\u{7B49}\u{5F85}\u{6A21}\u{5F0F}\u{8BBE}\u{7F6E}\u{5931}\u{8D25}\u{FF1A}${ack.error ?? 'unknown error'}`;
            return;
        }
        const mode = ack.config?.waitMode ?? null;
        $0073ed07eb3af726$var$elements.status.textContent = `\u{5DF2}\u{521B}\u{5EFA}\u{623F}\u{95F4}\u{FF08}\u{670D}\u{52A1}\u{7AEF}\u{6743}\u{5A01}\u{6A21}\u{5F0F}\u{FF09}\u{3002}\u{7B49}\u{5F85}\u{6A21}\u{5F0F}\u{5DF2}\u{751F}\u{6548}\u{FF1A}${$0073ed07eb3af726$var$waitModeLabel(mode)}\u{3002}\u{5206}\u{4EAB}\u{94FE}\u{63A5}\u{7ED9}\u{5176}\u{4ED6}\u{73A9}\u{5BB6}\u{8FDB}\u{5165} /hand/\u{3002}`;
    });
    $0073ed07eb3af726$var$client.seats.on('update', ()=>{
        const authoritative = $0073ed07eb3af726$var$client.isAuthoritative();
        const isHost = $0073ed07eb3af726$var$client.seat === 0;
        $0073ed07eb3af726$var$setControlsEnabled($0073ed07eb3af726$var$elements, !authoritative && isHost);
        if (authoritative) return;
        if (!isHost && $0073ed07eb3af726$var$client.connected()) $0073ed07eb3af726$var$elements.status.textContent = "\u4EC5\u623F\u4E3B\uFF08seat=0\uFF09\u53EF\u5728\u6B64\u9875\u64CD\u4F5C\u5BF9\u5C40\u8BBE\u7F6E\u3002";
    });
    $0073ed07eb3af726$var$elements.deal.onclick = ()=>{
        if (!$0073ed07eb3af726$var$client?.connected() || !$0073ed07eb3af726$var$world) return;
        if ($0073ed07eb3af726$var$client.isAuthoritative()) return;
        const dealType = $0073ed07eb3af726$var$elements.dealType.value;
        const gameType = $0073ed07eb3af726$var$elements.gameType.value;
        const fives = $0073ed07eb3af726$var$elements.fives.value;
        const points = $0073ed07eb3af726$var$elements.points.value;
        $0073ed07eb3af726$var$world.deal(dealType, gameType, fives, points);
    };
    $0073ed07eb3af726$var$elements.resetPoints.onclick = ()=>{
        if (!$0073ed07eb3af726$var$client?.connected() || !$0073ed07eb3af726$var$world) return;
        if ($0073ed07eb3af726$var$client.isAuthoritative()) return;
        const points = $0073ed07eb3af726$var$elements.points.value;
        $0073ed07eb3af726$var$world.resetPoints(points);
    };
    $0073ed07eb3af726$var$elements.toggleDealer.onclick = ()=>{
        if ($0073ed07eb3af726$var$client?.isAuthoritative()) return;
        $0073ed07eb3af726$var$world?.toggleDealer();
    };
    $0073ed07eb3af726$var$elements.toggleHonba.onclick = ()=>{
        if ($0073ed07eb3af726$var$client?.isAuthoritative()) return;
        $0073ed07eb3af726$var$world?.toggleHonba();
    };
    $0073ed07eb3af726$var$setControlsEnabled($0073ed07eb3af726$var$elements, false);
    $0073ed07eb3af726$var$client.new((0, $iRbTC.getWsUrl)(), {
        friendConfig: $0073ed07eb3af726$var$wantFriendConfig ?? undefined
    });
};
$0073ed07eb3af726$var$elements.create.onclick = ()=>{
    $0073ed07eb3af726$var$createRoom();
};


//# sourceMappingURL=mobile.7231beb1.js.map
